import { gql } from "@apollo/client";

export const GET_ANIMAL_GROUPS_INFO = gql`
  query AnimalGroup($domain: String!, $input: BasicQueryInfoInput!, $ifIncludeAnimalCount: Boolean!) {
    animalGroup {
      animalGroup(domain: $domain, input: $input) {
        name
        animal_group_id
        animalsCount(domain: $domain) @include(if: $ifIncludeAnimalCount)
      }
    }
  }
`

export type AnimalGroupInfo = {
  name: string;
  animal_group_id: number,
  animalsCount?: number,
};
 
export interface AnimalGroupResponse {
  animalGroup: {
    animalGroup: AnimalGroupInfo[]
  }
}
